import { useEffect } from 'react';

/** Bottom nav + fixed overlay CTAs use very high z-index; lift Radix dialog above them. */
const OVERLAY_Z = '2147483646';
const CONTENT_Z = '2147483647';

/**
 * Ensures the most recently opened Radix dialog sits above wallet bottom nav
 * (z-index 2147483647) and fixed overlay buttons (e.g. Withdraw Cash at 9999).
 */
export function useWalletTopLayerDialog(isOpen: boolean) {
  useEffect(() => {
    if (!isOpen) return;

    const elevate = () => {
      const overlays = document.querySelectorAll('[data-slot="dialog-overlay"]');
      const lastOverlay = overlays[overlays.length - 1] as HTMLElement | undefined;
      if (lastOverlay) {
        lastOverlay.style.zIndex = OVERLAY_Z;
        lastOverlay.style.backgroundColor = 'rgba(15, 23, 42, 0.55)';
      }

      const contents = document.querySelectorAll('[data-slot="dialog-content"]');
      const lastContent = contents[contents.length - 1] as HTMLElement | undefined;
      if (lastContent) {
        lastContent.style.zIndex = CONTENT_Z;
      }
    };

    const raf = requestAnimationFrame(elevate);
    return () => cancelAnimationFrame(raf);
  }, [isOpen]);
}
